import { useRouter } from 'next/router'

import { css } from '@emotion/react'

import Star from '@/components/icons/Star'
import { getNavigationIcon } from '@/constants/navigationAssets'

import { Container, Icon } from './Stars.styled'

interface Props {
  grade: string
  prefix: string
  small?: boolean
}

function Stars(props: Props) {
  const { grade, prefix, small = false } = props
  const parsedGrade = Number(grade)
  const router = useRouter()
  const starUrl =
    router.query.slug === 'legia-warszawa'
      ? getNavigationIcon('starLegia')
      : getNavigationIcon('star')

  return (
    <Container>
      {[...Array(5)].map((x, i) =>
        i + 1 < parsedGrade ? (
          <Icon key={i} small={small}>
            <Star value={1} prefix={`${prefix}_${i}`} />
          </Icon>
        ) : (
          <Icon key={i} small={small}>
            <Star value={parsedGrade - i} prefix={`${prefix}_${i}`} />
          </Icon>
        )
      )}
    </Container>
  )
}

const starIconStyle = css`
  width: 42px;
  height: 40px;
`

export default Stars
